import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipoServicoComponent } from './tipo-servico.component';
import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { TipoServicoModalComponent } from './tipo-servico-modal/tipo-servico-modal.component';
import { GaleriaModule } from 'projects/ProjetoBaseAngular/app/admin/galeria/galeria.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GaleriaModule
  ],
  declarations: [
    TipoServicoComponent,
    TipoServicoModalComponent
  ]
})
export class TipoServicoModule { }
